<template>
<div>
  <el-menu v-if="language == 'CN'"  :default-active="activeIndex"
           style="height:80px;max-width: 1210px;margin: 0 auto;"
           :class="{'el-menu-demo':true,'top-nav':fd === '1'?true:false,'muenBk':yj,'zd':!zdShow}" mode="horizontal"
           class="muen-wk"
  >
    <img class="muen-img" :src="logSrc">
    <el-menu-item v-show="!isShow" style="float: right;margin-right:202px;line-height: 70px"  @click="changeLanguage()" ><span style="color:rgb(8, 58, 111);font-weight: bold;">中</span>|<span>EN</span></el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="2" @click="skipping(6)" >联系我们</el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="3" @click="skipping(5)">新闻中心</el-menu-item>
    <!-- <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="4" @click="skipping(4)">已投项目</el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="5" @click="skipping(3)">道远团队</el-menu-item> -->
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="6" @click="skipping(2)">关于我们</el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="7" @click="skipping(1)">首页</el-menu-item>
    <el-menu-item v-show="fkx" style="float: right;margin-right:72px"  ><div style="width: 4px;height: 42px;background-color: #083A6F;margin-top: 14px;"></div></el-menu-item>
    <el-submenu v-show="isShow" style="float: right">
      <template slot="title"><img style=" width: 30px;height: 30px;margin-top: 3px" :src="logSrc1"  iocn="el-icon-s-unfold"></template>
      <el-menu-item @click="skipping(1)">首页</el-menu-item>
      <el-menu-item @click="skipping(2)">关于我们</el-menu-item>
      <!-- <el-menu-item @click="skipping(3)">道远团队</el-menu-item>
      <el-menu-item @click="skipping(4)">已投项目</el-menu-item> -->
      <el-menu-item @click="skipping(5)">新闻中心</el-menu-item>
      <el-menu-item @click="skipping(6)" >联系我们</el-menu-item>
       <el-menu-item @click="changeLanguage()" ><span style="color:rgb(8, 58, 111);font-weight: bold;">中</span>|<span>EN</span></el-menu-item>
    </el-submenu>
  </el-menu>
    <el-menu v-if="language == 'EN'"  :default-active="activeIndex"
           style="height:80px;max-width: 1210px;margin: 0 auto;"
           :class="{'el-menu-demo':true,'top-nav':fd === '1'?true:false,'muenBk':yj,'zd':!zdShow}" mode="horizontal"
           class="muen-wk"
  >
    <img class="muen-img" :src="logSrc">
    <el-menu-item v-show="!isShow" style="float: right;margin-right:180px;line-height: 70px"  @click="changeLanguage()" ><span>中</span>|<span style="color:rgb(8, 58, 111);font-weight: bold;">EN</span></el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="2" @click="skipping(6)" >Contact Us</el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="3" @click="skipping(5)">News Center</el-menu-item>
    <!-- <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="4" @click="skipping(4)">已投项目</el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="5" @click="skipping(3)">道远团队</el-menu-item> -->
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="6" @click="skipping(2)">About Us</el-menu-item>
    <el-menu-item v-show="!isShow" style="float: right;line-height: 70px" index="7" @click="skipping(1)">Home Page</el-menu-item>
    <el-submenu v-show="isShow" style="float: right">
      <template slot="title"><img style=" width: 30px;height: 30px;margin-top: 3px" :src="logSrc1"  iocn="el-icon-s-unfold"></template>
      <el-menu-item @click="skipping(1)">Home Page</el-menu-item>
      <el-menu-item @click="skipping(2)">About Us</el-menu-item>
      <!-- <el-menu-item @click="skipping(3)">道远团队</el-menu-item>
      <el-menu-item @click="skipping(4)">已投项目</el-menu-item> -->
      <el-menu-item @click="skipping(5)">News Center</el-menu-item>
      <el-menu-item @click="skipping(6)" >Contact Us</el-menu-item>
      <el-menu-item @click="changeLanguage()" ><span>中</span>|<span style="color:rgb(8, 58, 111);font-weight: bold;">EN</span></el-menu-item>
    </el-submenu>
  </el-menu>
</div>
</template>

<script>
    export default {
        name: "head-menu",
        props: {
          width1:0,
          current:String,
          fd:String
        },
        data(){
          return{
            logSrc:require('@/assets/log.png'),
            logSrc1:require('@/assets/1.jpg'),
            language:'EN',
            isShow:false,
            zdShow:false,
            activeIndex:this.current,
            yj:true,
            fkx:true
          }
        },
      created() {
        if(document.documentElement.clientWidth>1210){
          this.zdShow=false
          this.isShow=false
          this.yj=true
          this.fkx=true
        }else{
          this.yj=false
          this.fkx=false
          if(document.documentElement.clientWidth<1025){
            console.log("进入")
            this.isShow=true
            this.zdShow=true
          }else{
            this.zdShow=true
            this.isShow=false
          }

        }
      },
      watch:{
      width1(val,oldval){
          if(val>1210){
            this.zdShow=false
            this.isShow=false
            this.yj=true
            this.fkx=true
          }else{
            this.yj=false
            this.fkx=false
            if(val<1025){
              console.log("进入菜单")
              this.isShow=true
              this.zdShow=true
            }else{
              this.zdShow=true
              this.isShow=false
            }

          }
//          console.log("头")
//          console.log(val)
      }
      },
      mounted() {
            if(localStorage.getItem('language')){
      this.language =localStorage.getItem('language')
    }else{
      this.language = 'CN'
    }
        console.log("加载")
        window.onresize = () => {
          return (() => {
            this.$windowWidth=document.body.clientWidth;
            console.log("宽度"+this.$windowWidth)
            if(document.body.clientWidth>1210){
                this.zdShow=false
                this.isShow=false
                this.yj=true
                this.fkx=true
              }else{
                this.yj=false
                this.fkx=false
                if(document.body.clientWidth<1025){
                  console.log("进入菜单")
                  this.isShow=true
                  this.zdShow=true
                }else{
                  this.zdShow=true
                  this.isShow=false
                }

            }

          })();
        };
      },
      methods:{
        skipping(varx){
          if(varx===1){
            if(localStorage.getItem('language')=='CN'){
              this.$router.push({path:'/'})
            }else{
              this.$router.push({path:'/en/'})
            }
          }else if(varx===2){
            if(localStorage.getItem('language')=='CN'){
              this.$router.push({path:'/aboutUs'})
            }else{
              this.$router.push({path:'/en/aboutUs'})
            }
          }else if(varx===3){
            if(localStorage.getItem('language')=='CN'){
              this.$router.push({path:'/ourTeam'})
            }else{
              this.$router.push({path:'/en/ourTeam'})
            }
          }else if(varx===4)
          {
            if(localStorage.getItem('language')=='CN'){
              this.$router.push({path:'/yiyaoxiangmu'})
            }else{
              this.$router.push({path:'/yiyaoxiangmu'})
            }
          }else if(varx===5)
          {
            if(localStorage.getItem('language')=='CN'){
              this.$router.push({path:'/newsCenter'})
            }else{
              this.$router.push({path:'/en/newsCenter'})
            }
          }else if(varx===6)
          {
            if(localStorage.getItem('language')=='CN'){
              this.$router.push({path:'/daoyuanfamily'})
            }else{
              this.$router.push({path:'/en/daoyuanfamily'})
            }
          }
        },
        changeLanguage(){
          if(localStorage.getItem('language')=='CN'){
            localStorage.setItem('language','EN')
            let url = "http://www.taocapital.cn/en"
            let name = this.$route.name
            console.log(name)
            this.$router.push({name:'En'+name})
          }else{
            localStorage.setItem('language','CN')
            let url = "http://www.taocapital.cn"
            let name = this.$route.name
            console.log(name)
            name = name.substr(2)
            this.$router.push({name:name})
          }
          this.$forceUpdate()
          location.reload()
        }
      }
    }
</script>

<style>
  .el-icon-arrow-down:before {
    content: "";
  }
  .top-nav {
    /*顶部导航栏*/
    background: rgba(244, 245, 246,1) !important;
    opacity:0.7 !important;
    position: fixed !important;
    width: 100% !important;
    z-index: 10 !important;
  }
  .el-menu-item{
    font-size:16px !important;
    margin-top: 6px !important;
    overflow-y: hidden;
    line-height: 72px;
    margin-left:64px !important;
    font-family:Microsoft YaHei;
  }
    .el-menu-item{
      padding: 0px;
  }
  .muenBk{
      box-shadow:0px 2px 5px 0px rgba(0, 0, 0, 0.35);
      opacity:0.95;
      border-radius:5px;
      opacity:0.90;
  }
  .zd{
    top:30px
  }
.el-menu--horizontal>.el-menu-item.is-active{
    font-weight:bold;
    color:rgba(8,58,111,1);
    border-bottom: 2px solid #fff;
  }
  .muen-img{
    width: 156px;height: 51px;margin-top: 14px;margin-left:72px;cursor: pointer;border: 0px !important;
  }
 @media screen and (max-width:1025px){
   .muen-img{
     width: 130px;height: 40px;margin-top: 10px;margin-left:20px;cursor: pointer;border: 0px !important;
   }
   .muen-wk{
     height:65px!important;
   }
 }
  .el-submenu__title:hover{
    background-color:rgba(8,58,111,0) !important;
  }
</style>



// WEBPACK FOOTER //
// src/share/head-mean.vue